import { breakpoints } from '@fiverr-private/sass/helpers';

export const IMAGE_RESOLUTIONS = [
    {
        media: `(min-width: ${breakpoints.md}px)`,
        config: { width: 909 },
    },
    {
        media: `(min-width: ${breakpoints.sm}px)`,
        config: { width: 730 },
    },
    {
        media: `(min-width: ${breakpoints.xs}px)`,
        config: { width: 322 },
    },
];
